export const convertFileToBase64 = async (file: File): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64data = reader.result as string;
      resolve(base64data);
    };
    reader.onerror = () => reject(new Error('파일 변환 실패'));
    reader.readAsDataURL(file);
  });
};

export const convertUrlToFile = async (url: string, filename = 'photo.png'): Promise<File> => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new File([blob], filename, { type: 'image/png' });
};

export const convertBlobToBase64 = async (blob: Blob): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64data = reader.result as string;
      resolve(base64data);
    };
    reader.onerror = () => reject(new Error('Blob 변환 실패'));
    reader.readAsDataURL(blob);
  });
};
